import { useVehiclePhotosByKind } from 'Components/Gallery';

import { DamageCard } from '../ConditionAndDamageSection/Components/DamageCard';

import styles from './MobilizeWheelDamageSection.module.scss';

export const MobilizeWheelDamageSection: React.FC = () => {
	const images = useVehiclePhotosByKind(['damage_wheel']);

	if (images.length === 0) {
		return <p>No wheel damage reported</p>;
	}

	return (
		<div className={styles.grid} data-testid="mobilize-wheel-damage-section">
			{images.map((image) => (
				<DamageCard key={image.id} image={image} showOverlay={false} />
			))}
		</div>
	);
};
